import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "../details.css";
import { useSelector } from "react-redux";

export default function KeyExectives(props) {
  const values = props.values;
  const t = props.t;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const stoqqyLang = window.localStorage.getItem("stoqqyLang");
  return (
    <div
      style={{
        marginTop: "20px",
      }}
    >
      <div
        style={{
          maxWidth: "95vw",
          overflowX: isDesktopOrLaptop ? "" : "scroll",
        }}
      >
        <div
          style={{
            height: (values?.length + 2) * 41,
            width: 840,
          }}
          className="ag-theme-alpine invisible-scrollbar"
        >
          <AgGridReact
            defaultColDef={{
              sortable: false,
            }}
            rowData={values}
          >
            <AgGridColumn field={"Name"} width={230} headerName={t("name")} />
            <AgGridColumn field={"Title"} width={380} headerName={t("title")} />
            <AgGridColumn field={"Age"} width={100} headerName={t("age")} />
            <AgGridColumn field={"Since"} width={100} headerName={t("since")} />
          </AgGridReact>
        </div>
      </div>
    </div>
  );
}
